import styled from 'styled-components';

export const BoldSpanMidSize = styled.span`
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  padding-right: 6px;
  color: var(--color-text-base, #2e2e2e);
`;

export const BoldSpanLargeSize = styled.span`
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  padding-right: 6px;
`;

export const ColoredBoldSpanLargeSize = styled.span`
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  padding-right: 6px;
  color: var(--color-primary, #41aaaf);
`;

export const SSOLoginSpan = styled.span.attrs({
  className: 'scope-sso-login-label',
})`
  font-family: Inter, sans-serif;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-align: inherit;
  color: inherit;
  padding: 0;
`;

export const StrongTitleSpan = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
  color: var(--color-text-dark, #042a2a);
  margin-bottom: 10px;
`;

export const GraySpan = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  color: var(--color-text-muted, #5a6a6a);
`;

export const BlackSpan = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: var(--color-text-dark, #042a2a);
`;

export const CardTitleSpan = styled.span`
  font-family: Inter;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: var(--color-text-base, #2e2e2e);
`;

export const CardTitleLargeSpan = styled.span`
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  color: var(--color-text-base, #2e2e2e);
`;

